<h3>Search {{mode}}: {{searchPhrase}}</h3>
<p *ngIf="!tickets">Loading...</p>
<nz-table *ngIf="tickets"
	[nzBordered]="true"
	[nzData]="tickets"
	[nzFrontPagination]="false"
	[nzShowPagination]="false">
	<thead>
		<tr>
			<th>Assigned To</th>
			<th *ngIf="showPolicyColumn">Policy</th>
			<th>Type</th>
			<th>Membership</th>
			<th>Member Details</th>
			<th>ID/Passport Number</th>
			<th>Category</th>
			<th>Status</th>
			<th>Last Action At</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let ticket of tickets; let i = index" class="cursor-pointer" (dblclick)="openTicket(ticket)">
			<td *ngIf="!ticket.assignedToAgent">-</td>
			<td *ngIf="ticket.assignedToAgent">{{ ticket.assignedToAgent.firstName}}</td>
			<td *ngIf="showPolicyColumn">{{ ticket.policy?.policyNumber??'-' }}</td>
			<td>{{ ticket.workflowLabel }}</td>
			<td>{{ ticket.membership?.membershipNumber??'-' }}</td>
			<td>{{ ticket.member.surname }} {{ticket.member.name}}</td>
			<td>{{ ticket.member.idNumber }}</td>
			<td>{{ ticket.membership?.category??'-' }}</td>
			<td>{{ ticket.currentStepAndStateLabel }}</td>
			<td>{{ ticket.lastActionedAt | date }}</td>
		</tr>
	</tbody>
</nz-table>
